/** Timeout (ms) for AudioContext.resume() before considering it failed. */
export const AUDIO_CONTEXT_RESUME_TIMEOUT_MS = 2000;

/** Short delay (ms) after MediaRecorder.stop() to let final data flush. */
export const MEDIA_RECORDER_STOP_SETTLE_MS = 100;

/** Delay (ms) after stopping mic tracks to let iOS release audio hardware. */
export const MIC_TRACKS_RELEASE_DELAY_MS = 1500;

/** Increasing delays (ms) between iOS pipeline recreation attempts. */
export const IOS_RECOVERY_RETRY_DELAYS_MS = [0, 2000, 3000, 5000];

export const DEFAULT_NOTE_TYPES = [
  {
    name: "SOAP",
    type: "SOAP",
  },
  {
    name: "DAP",
    type: "DAP",
  },
  {
    name: "Therapy Intake",
    type: "Intake",
  },
  {
    name: "EMDR",
    type: "EMDR",
  },
  {
    name: "Psychiatric Intake",
    type: "PSYCHIATRIC_INTAKE",
  },
  {
    name: "Psychiatric Followup (SOAP)",
    type: "PSYCHIATRIC_FOLLOW_UP_SOAP",
  },

  {
    name: "EAP Intake",
    type: "EAP_INTAKE",
  },
  {
    name: "SOAP (Speech Therapy)",
    type: "SOAP_SPEECH_THERAPY",
  },
  {
    name: "Consult Note",
    type: "CONSULT_NOTE",
  },
];

export const SOL_NOTE_TYPES = [
  {
    name: "Psychiatric Intake",
    type: "SOL_PSYCH_INTAKE",
  },
  {
    name: "Psychiatric Followup",
    type: "PSYCHIATRIC_FOLLOW_UP",
  },
  {
    name: "Therapy Intake",
    type: "THERAPY_INTAKE",
  },
  {
    name: "Therapy Followup (SOAP)",
    type: "THERAPY_FOLLOW_UP_SOAP",
  },
  {
    name: "Therapy Followup (DAP)",
    type: "THERAPY_FOLLOW_UP_DAP",
  },
  {
    name: "EMDR",
    type: "EMDR",
  },
  {
    name: "Consult Note",
    type: "CONSULT_NOTE",
  },
];

export const LLT_NOTE_TYPES = [
  {
    name: "SOAP",
    type: "SOAP",
  },
  {
    name: "SOAP (Speech Therapy)",
    type: "SOAP_SPEECH_THERAPY",
  },
];

export const GWUL_NOTE_TYPES = [
  {
    name: "SOAP",
    type: "SOAP",
  },
];
